import React, { useState } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import { updateUserPassword } from "Services/ServiceRequest";
import userclasses from "./User.module.css";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";

Modal.setAppElement("#root");

function PasswordModal({ setModal, showModal, selectedUser }) {
    const [passwords, setPasswords] = useState({ password: "", confirmPassword: "" });
    const [loading, setLoading] = useState(false);

    const UpdateHandler = async () => {
        if (!passwords.password || !passwords.confirmPassword) {
            Swal.fire("Warning", "Please fill all fields", "warning");
            return;
        }

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(passwords.password)) {
            Swal.fire({
                title: "Invalid Password",
                html: `Password must be at least <b>8 characters</b> and contain:<br/>
                - At least <b>1 uppercase</b> letter<br/>
                - At least <b>1 lowercase</b> letter<br/>
                - At least <b>1 number</b><br/>
                - At least <b>1 special character</b> (@$!%*?&)`,
                icon: "warning",
            });
            return;
        }

        if (passwords.password !== passwords.confirmPassword) {
            Swal.fire("Warning", "Passwords do not match", "warning");
            return;
        }


        setLoading(true);
        try {
            const response = await updateUserPassword(selectedUser.userId, passwords);

            if (response?.data?.Status === 1) {
                setModal(false);
                setLoading(false);
                Swal.fire({
                    title: "Success",
                    text: response?.data?.Message || "Password updated successfully",
                    icon: "success",
                });
                setPasswords({ password: "", confirmPassword: "" });
            } else {
                Swal.fire({
                    title: "Error",
                    text: response?.data?.Message || "Failed to update password",
                    icon: "error",
                });
            }
        } catch (err) {
            setLoading(false);
            Swal.fire({
                title: "Error",
                text: err?.response?.data?.Message || "Something went wrong please try again",
                icon: "error",
            });
        }
    };

    return (
        <Modal
            isOpen={showModal}
            onRequestClose={() => {
                setModal(false);
                setPasswords({ password: "", confirmPassword: "" });
            }}
            className={"modal"}
            overlayClassName={"overlay"}>
            <div className="Approve_Modal_Container">
                <h3>Update Password for {selectedUser?.fullName}</h3>
                <button
                    className="btn_close"
                    onClick={() => {
                        setModal(false);
                        setPasswords({ password: "", confirmPassword: "" });
                    }}>
                    <MdClose />
                </button>
                <div className={userclasses["form-control"]}>
                    <label htmlFor="newPassword">New Password</label>
                    <input
                        id="newPassword"
                        type="password"
                        autoComplete="new-password"
                        value={passwords.password}
                        onChange={(e) => setPasswords({ ...passwords, password: e.target.value })}
                        placeholder="Enter New Password"
                    />
                </div>
                <div className={userclasses["form-control"]}>
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <input
                        id="confirmPassword"
                        type="password"
                        autoComplete="new-password"
                        value={passwords.confirmPassword}
                        onChange={(e) => setPasswords({ ...passwords, confirmPassword: e.target.value })}
                        placeholder="Confirm New Password"
                    />

                </div>
                {loading ? (
                    <div className="Request_approve_reject">
                        <ReactLoading
                            color="green"
                            type="spokes"
                            height={30}
                            width={30}
                        />
                    </div>
                ) : (
                    <div className="Request_approve_reject">
                        <button onClick={UpdateHandler}>
                            Update
                        </button>
                    </div>
                )}
            </div>
        </Modal>
    );
}

export default PasswordModal;
